import { Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';

import type { IUnitCreate } from '../types';

import { useUnitCreate } from '../queries';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';
import { FormCommon } from './FormCommon';

export const UnitCreate = (): JSX.Element => {
  const { t } = useTranslation();
  const [form] = Form.useForm<IUnitCreate>();
  const { mutate: unitCreate, isLoading } = useUnitCreate();

  const submitHandler = (data: IUnitCreate) => {
    unitCreate(data);
  };

  return (
    <>
      <PageHeader
        title={t('units.form.createTitle')}
        description={t('units.form.createDescription')}
        navigateBackUrl={routes.units()}
      />
      <Form name='unitCreate' form={form} requiredMark='optional' layout='vertical' onFinish={submitHandler} scrollToFirstError>
        <FormCommon />

        <Form.Item>
          <Button type='primary' htmlType='submit' loading={isLoading}>
            {t('global.save')}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};
